var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btnflex button",style:(_vm.styleMerge)},[_c('div',{staticClass:"current-active"}),_c('div',[_vm._v(_vm._s(_vm.viewData.buttonName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }